import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as UIActions from '../../../actions/UIActions';
import ListItemDrawer from '../../../components/ListItemDrawer';
import { AsideSearchHints as Hints } from '../../../resources/hints';
// import ImageFilterCheckbox from './ImageFilterCheckbox';
import DataSourceField from './DataSourceField';
import ObjectCategoryField from './ObjectCategoryField';
import CameraIDField from './CameraIDField';
import BatchIDField from './BatchIDField';
import ImageSNField from './ImageSNField';
// import InfraredModeField from './InfraredModeField';
import ImageSizeField from './ImageSizeField';
import './ImageSearchGroup.sass';

const ImageSearchGroup = ({ UI, dispatch }) => {
  const {
    showSourceInput,
    showCategoriesInput,
    showCameraInput,
    showBatchInput,
    showImageSNInput,
    // showInfraredModeInput,
    showImageSizeInput
    // showImageTimeInput
  } = UI;

  const drawerData = [
    // TODO: Support
    // {
    //   title: 'Filter Results',
    //   show: true,
    //   onClick() { },
    //   children: <ImageFilterCheckbox />,
    //   ...Hints.filterHint
    // },
    {
      title: 'Source Names',
      show: showSourceInput,
      onClick: () => dispatch(UIActions.toggleSourceInput()),
      children: <DataSourceField />,
      ...Hints.sourceHint
    },
    {
      title: 'Umbo Categories',
      show: showCategoriesInput,
      onClick: () => dispatch(UIActions.toggleCategoriesInput()),
      children: <ObjectCategoryField />,
      ...Hints.categoriesHint
    },
    {
      title: 'Batch Names',
      show: showBatchInput,
      onClick: () => dispatch(UIActions.toggleBatchInput()),
      children: <BatchIDField />,
      ...Hints.batchIDHint
    },
    {
      title: 'Image SNs',
      show: showImageSNInput,
      onClick: () => dispatch(UIActions.toggleImageSnInput()),
      children: <ImageSNField />,
      ...Hints.imageSNHint
    },
    {
      title: 'Camera IDs',
      show: showCameraInput,
      onClick: () => dispatch(UIActions.toggleCameraInput()),
      children: <CameraIDField />,
      ...Hints.cameraIDHint
    },
    // {
    //   title: 'Infrared Mode',
    //   show: showInfraredModeInput,
    //   onClick: () => dispatch(UIActions.toggleInfraredModeInput()),
    //   children: <InfraredModeField />,
    //   ...Hints.infraredModeHint
    // },
    {
      title: 'Image Size',
      show: showImageSizeInput,
      onClick: () => dispatch(UIActions.toggleImageSizeInput()),
      children: <ImageSizeField />,
      ...Hints.imageSizeHint
    }
    // {
    //   title: 'Image Time',
    //   show: showImageTimeInput,
    //   onClick: () => dispatch(UIActions.toggleImageTimeInput()),
    //   children: 'Image Time Search',
    //   ...Hints.imageTimeHint
    // }
  ];

  const renderDrawers = drawerData.map(({ children, ...data }, i) => (
    <ListItemDrawer key={i} {...data}>
      {children}
    </ListItemDrawer>
  ));

  return (
    <div className="ImageSearchGroup">
      {renderDrawers}
    </div>
  );
};

ImageSearchGroup.propTypes = {
  dispatch: PropTypes.func.isRequired,
  UI: PropTypes.shape({
    showSourceInput: PropTypes.bool.isRequired,
    showCategoriesInput: PropTypes.bool.isRequired,
    showCameraInput: PropTypes.bool.isRequired,
    showBatchInput: PropTypes.bool.isRequired,
    showImageSnInput: PropTypes.bool.isRequired,
    showInfraredModeInput: PropTypes.bool.isRequired,
    showImageSizeInput: PropTypes.bool.isRequired,
    showImageTimeInput: PropTypes.bool.isRequired
  }).isRequired
};

function mapStateToProps({ UI }) {
  return { UI };
}

export default connect(mapStateToProps)(ImageSearchGroup);



// WEBPACK FOOTER //
// ./src/containers/Aside/ImageSearchGroup/ImageSearchGroup.jsx